/**
 * is Function
 */
export const isFunction = (val: any): val is Function =>
  typeof val === 'function';
